import {atom} from "recoil"


const keyword = atom<string>({
    key: "roleList@search-keyword",
    default: '',
})

const showRegisterWindow = atom<boolean>({
    key: "roleList@show-register-window",
    default: false
})
export const RoleStore = {
    keyword,
    showRegisterWindow,
}